import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { CleanLayoutComponent } from './layouts/clean/clean-layout.component';
import { OrderPrintComponent } from './orders/print/print.component';
import { PaymentsListComponent } from './payments/list/list.component';
import { PaymentsMakeComponent } from './payments/make/make.component';
import { AuthGuard, FeaturesGuard } from './shared/auth';
import { ThemesComponent } from './themes/themes.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'inicio',
        pathMatch: 'full',
      },
      {
        path: 'inicio',
        component: HomeComponent,
        data: {
          breadcrumb: 'Inicio Rápido',
          hideBreadcrumb: true,
        },
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'carritos',
        loadChildren: () => import('./carts/carts.module').then(m => m.CartsModule),
      },
      {
        path: 'pedidos',
        loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule),
      },
      {
        path: 'cobros/nuevo',
        component: PaymentsMakeComponent,
        data: {
          breadcrumb: 'Realizar Cobro',
        },
      },
      {
        path: 'cobros/',
        redirectTo: 'cobros',
        pathMatch: 'full',
      },
      {
        path: 'cobros',
        component: PaymentsListComponent,
        data: {
          breadcrumb: 'Lista de Cobros',
        },
      },
      {
        path: 'reportes',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
      },
      {
        path: 'clientes',
        loadChildren: () => import('./customers/customers.module').then(m => m.CustomersModule),
      },
      {
        path: 'lealtad',
        loadChildren: () => import('./loyalty/loyalty.module').then(m => m.LoyaltyModule),
      },
      {
        path: 'integraciones',
        loadChildren: () => import('./integrations/integrations.module').then(m => m.IntegrationsModule),
      },
      {
        path: 'cuenta',
        loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
      },
      {
        path: 'productos',
        loadChildren: () => import('./products/products.module').then(m => m.ProductsModule),
      },
      {
        path: 'widget',
        loadChildren: () => import('./widget/widget.module').then(m => m.WidgetModule),
      },
      {
        path: 'webintegrations',
        loadChildren: () => import('./webintegrations/webintegrations.module').then(m => m.WebintegrationsModule),
      },
      {
        path: 'content-manager',
        loadChildren: () => import('./content-manager/content-manager.module').then(m => m.ContentManagerModule),
      },
      {
        path: 'suscripciones',
        loadChildren: () => import('./subscriptions/subscriptions.module').then(m => m.SubscriptionsModule),
      },
      {
        path: 'marketplace',
        loadChildren: () => import('./marketplace/marketplace.module').then(m => m.MarketplaceModule),
      },
      {
        path: 'sitio/temas',
        component: ThemesComponent,
        canActivate: [FeaturesGuard],
        data: {
          breadcrumb: 'Temas',
          require: ['website'],
        },
      },
      {
        path: 'logistica',
        loadChildren: () => import('./logistics/logistics.module').then(m => m.LogisticsModule),
      },
      {
        path: 'capacidad-instalada',
        loadChildren: () => import('./installed-capacity/installed-capacity.module').then(m => m.InstalledCapacityModule),
      },
      {
        path: 'campaign',
        loadChildren: () => import('./campaigns/campaigns.module').then(m => m.CampaignsModule),
      },
      {
        path: 'supply-chain',
        loadChildren: () => import('./supply-chain/supply-chain.module').then(m => m.SupplyChainModule),
      },
    ],
  },
  {
    path: '',
    component: CleanLayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
      },
      {
        path: 'error',
        loadChildren: () => import('./error/error.module').then(m => m.ErrorModule),
      },
      {
        path: 'landing',
        loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule),
      },
      {
        path: 'maintenance/offline-ui',
        loadChildren: () => import('./maintenance/offline-ui/offline-ui.module').then(m => m.OfflineUiModule),
      },
      {
        path: 'tema',
        canActivate: [AuthGuard],
        loadChildren: () => import('./theme-editor/theme-editor.module').then(m => m.ThemeEditorModule),
      },
      {
        path: 'print/pedido/:id',
        component: OrderPrintComponent,
      },
      {
        path: 'sitio/website-builder',
        canActivate: [FeaturesGuard],
        loadChildren: () => import('./website/website.module').then(m => m.WebsiteModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];
